import React, { useState, useEffect } from 'react'
import useOrders from 'store/OrdersProvider'
import SingleOrder from './components/SingleOrder'

const OrdersPage = () => {
  const { orders, fetchOrders } = useOrders()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchOrders().finally(() => setLoading(false))
    // eslint-disable-next-line
  }, [])

  if (loading) {
    return (
      <div className="bg-white rounded-2xl mb-6 border border-slate-200 overflow-hidden p-8 text-center">
        <p className="text-slate-500">იტვირთება...</p>
      </div>
    )
  }

  if (!orders || orders.length === 0) {
    return (
      <div className="bg-white rounded-2xl mb-6 border border-slate-200 overflow-hidden p-8 text-center">
        <p className="text-slate-500">შეკვეთები არ მოიძებნა.</p>
      </div>
    )
  }

  return (
    <div>
      {orders.map(order => (
        <SingleOrder key={order.id} order={order} />
      ))}
    </div>
  )
}

export default OrdersPage
